import React, { useEffect, useState } from 'react';

import './index.css'

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { MessagesState } from '../../../store/reducers/messagesReducer';
import { RootState } from '../../../store/index';

import { NotificationCenterService, NotificationLogCenter } from '../../../services/notificationCenter/notificationService';
import moment from 'moment';

//Componentes
import LcIconLink from '../../Generic/LcIconLink';
import LcToggle from '../../Form/LcToggle';
import { PPIconLink } from 'processor-plataform-ui';

import 'moment/locale/pt-br';
import LcLoading from '../../Generic/LcLoading';
import { TbPinned, TbPinnedOff } from 'react-icons/tb';
import { IoCheckmarkDoneOutline, IoCheckmarkOutline } from "react-icons/io5";


interface NotificationsProps {
    visible: boolean,
    onClose: Function
}

const Notifications: React.FC<NotificationsProps> = (props) => {

    moment.locale('pt-br');

    const user = useSelector<RootState, UserState>(state => state.user);
    const msgs = useSelector<RootState, MessagesState>(state => state.msgs);
    const dispatch = useDispatch();
    const serviceNotification = new NotificationCenterService(props);
    const [showAllMessages, setShowAllMessages] = useState(false);
     //Fake data
     const [messages, setMessages] = useState<any[]>([
        ...(msgs.messages || []),
        ...(msgs.alerts || [])
    ]);
    //#region Notifications
    const [isLoadingNotification, setIsLoadingNotification] = useState(false);
    //Busca
    const [searchVisible, setSearchVisible] = useState(false);
    const [search, setSearch] = useState("");

    const GetNotificationsAsync = async (OnlyUnread: boolean = false) => {
        setIsLoadingNotification(true);
        await serviceNotification.GetNotifications()
            .then((response: object[]) => {
                var sortedArray: any[] = response;
                if (OnlyUnread) sortedArray = sortedArray.filter(x => x.isRead == true)
                return sortedArray;
            })
            .catch(console.warn)
            .then(() => {
                setIsLoadingNotification(false);
            });
    }
    useEffect(() => {
        if (msgs.messages.length === 0 && msgs.lastUpdate === '') {
            getNewNotifications()
        }
    }, [msgs.messages])

    useEffect(() => {
        const listeningNotifications = async () => {
            let hasOrNot = await serviceNotification.GetHasnotReadNotifications();
            if (hasOrNot.unreadCount > 0) {
                let diff = diffBNotifications(msgs.messages, hasOrNot.notifications.filter(msg => msg.isRead))
                diff.forEach(msg => {
                    serviceNotification.PostInterfaceNotification(dispatch, msg);
                })
                dispatch({ type: 'MSG_UPDATE', payload: diff });
                dispatch({ type: 'MSG_UPDATE_LAST_TIME', payload: new Date().toISOString() });
            } else {
                setIsLoadingNotification(false);
            }
        }
        // const intervalId = setInterval(listeningNotifications, 300000);

        // return () => clearInterval(intervalId);
        listeningNotifications()
    }, [user.refreshFlag, user.ClientGroupSelected])

    const diffBNotifications = (oldNotifications: NotificationLogCenter[], newNotifications: NotificationLogCenter[]) => {
        const uniqueNotification: NotificationLogCenter[] = [];

        oldNotifications.forEach(obj1 => {
            if (!newNotifications.some(obj2 => obj2.notificationId === obj1.notificationId && obj2.isRead === obj1.isRead)) {
                uniqueNotification.push(obj1);
            }
        });

        newNotifications.forEach(obj2 => {
            if (!oldNotifications.some(obj1 => obj1.notificationId === obj2.notificationId && obj1.isRead === obj2.isRead)) {
                uniqueNotification.push(obj2);
            }
        });

        return uniqueNotification.filter(obj => obj.isRead === false);
    }

    const getNewNotifications = async () => {
        await serviceNotification.GetNotifications()
            .then(function (response: object[]) {
                dispatch({ type: 'MSG_UPDATE', payload: response || [] });
                dispatch({ type: 'MSG_UPDATE_LAST_TIME', payload: new Date().toISOString() });
            })
            .catch(console.warn)
            .then(() => {
                setIsLoadingNotification(false);
            });
    }

    const loadNotifications = async (OnlyUnread: boolean = false) => {
        const canGetMessages = ((!msgs || !msgs.lastUpdate || new Date().getTime() - new Date(msgs.lastUpdate).getTime() > 300000) && (msgs.messages.length == 0));
        console.log(canGetMessages)
        if (user.email && canGetMessages) await GetNotificationsAsync()
    }

    useEffect(() => {
        setMessages(
            [...msgs.messages, ...msgs.alerts]
        )
    }, [msgs])

    const toggleMessageRead = (msg: any, type?: string ) => {

        if (msg.type !== "alert") {
            setMessages([...messages.map(m => { return m.id === msg.id ? type === 'pinned' ? { ...m, pinned: !m.pinned } : { ...m, isRead: !m.isRead } : m })]);

            //MSG_UPDATE
            dispatch({
                type: 'MSG_UPDATE',
                payload: msgs.messages.map(m => { return m.id === msg.id ?  type === 'pinned' ? { ...m, pinned: !m.pinned } : { ...m, isRead: !m.isRead } : m })
            });

            type === 'pinned' ? 
            serviceNotification.PostNotifications({ ...msg, pinned: !msg.pinned })
                .then(response => {
                    loadNotifications();
                })
                .catch( (error) => {
                    console.error(`ERRO: ${error}`)
                })
            :
            serviceNotification.PostNotifications({ ...msg, isRead: !msg.isRead })
                .then(response => {
                    loadNotifications();
                })
                .catch( (error) => {
                    console.error(`ERRO: ${error}`)
                }) 
        } else {
            dispatch({
                type: 'MSG_UPDATE_ALERT',
                payload: msgs.alerts.filter(m => m.id !== msg.id)
            });
        }

    }
    const setMessageReadAll = () => {

        //Mensagens do serviço
        dispatch({ type: 'MSG_UPDATE', payload: msgs.messages.map(m => { return { ...m, isRead: true } }) });
        msgs.messages.forEach(m => {
            if (!m.isRead)
                serviceNotification.PostNotifications({ ...m, isRead: true })
                    .catch(console.warn)
        })

        //Mensagens do layout
        dispatch({ type: 'MSG_UPDATE_ALERT', payload: [] });
    }

    //Delay close 
    var timerClose;
    const onMouseLeave = () => {
        clearTimeout(timerClose);
        timerClose = setTimeout(() => { props.onClose(false) }, 500);
    }

    const checkExpiredDate = (date) => {

        var _d = new Date(date);
        var expiredDate = Date.UTC(
            _d.getUTCFullYear(),
            _d.getUTCMonth(),
            _d.getUTCDate(),
            _d.getUTCHours(),
            _d.getUTCMinutes(),
            _d.getUTCSeconds()
        );

        var now = new Date();
        var now_utc = Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds()
        );

        if (now_utc > expiredDate) {
            return true
        } else {
            return false
        }
    }
    
    return (
        <div className={`notifications${props.visible ? " visible" : ""}`}
            onMouseOver={() => { clearTimeout(timerClose) }}
            onMouseLeave={() => onMouseLeave()}
        >

            <div className="header">
                <div className='title'>Notificações</div>
                <div className="functions">
                    <LcIconLink icon="ppi ppi-search" color={search.length > 0 ? "orange" : undefined} onClick={() => setSearchVisible(!searchVisible)} />
                    <LcIconLink icon="ppi ppi-check-double" disabled={!messages.find(m => !m.isRead)} tooltip='Marcar todas como lida' tooltipPosition='right' onClick={() => setMessageReadAll()} />
                </div>

            </div>
            <div className={`search${searchVisible ? " visible" : ""}`}>
                <input
                    type="text"
                    onChange={event => setSearch(event.target.value)}
                    placeholder="Termo de busca"
                    value={search}
                />
                <i className='ppi ppi-x link' onClick={() => setSearch("")} />
            </div>
            <div className="subheader">
                <LcToggle toggled={showAllMessages} onChange={event => { setShowAllMessages(event.checked) }} title='Ver todas' />
            </div>
            <div className="body">
                {
                    messages
                        .filter(m => m.expiredDate)
                        .filter(m => m.pinned)
                        .filter(m => m.subject.indexOf(search) >= 0 || m.content.indexOf(search) >= 0)
                        .sort((a, b) => { return a.notificationDateTime > b.notificationDateTime ? -1 : 1 })
                        .map((m, i) => {
                            let expiredMsg: boolean = checkExpiredDate(m.expiredDate)
                            if (!expiredMsg) {
                                return (
                                    <div key={i} className={`message${m.isRead ? " read" : ""}`}>
                                        <div className="header">
                                            <div className="title">
                                                {
                                                    m.pinned &&
                                                    <i className='ppi ppi-pin' />
                                                }
                                                {m.subject}
                                            </div>
                                            <div className="functions">
                                                {
                                                    m.pinned ? 
                                                    <TbPinned size={'1.2rem'} onClick={() => toggleMessageRead(m, 'pinned')} />
                                                    :
                                                    <TbPinnedOff size={'1.2rem'}  onClick={() => toggleMessageRead(m, 'pinned')}  />
                                                }
                                                {/* <i className={` ppi ppi-${m.isRead ? "reply" : "pin"} ppi-3x`} /> */}
                                            </div>
                                        </div>
                                        <div className="when">{moment(m.notificationDateTime).format('DD/MM/YYYY HH:mm:ss')}</div>
                                        <div className="content" dangerouslySetInnerHTML={{ __html: m.content }} />
                                        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                                            {
                                                m.isRead ?
                                                <IoCheckmarkDoneOutline />
                                                :
                                                <IoCheckmarkOutline />
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        }
                    )

                }
                {
                showAllMessages ? 
                    messages
                        .filter(m => m.subject.indexOf(search) >= 0 || m.content.indexOf(search) >= 0)
                        .sort((a, b) => { return a.notificationDateTime > b.notificationDateTime ? -1 : 1 })
                        .slice(0, msgs.size)
                        .map((m, i) => {
                            return (
                                <div key={i} className={`message${m.isRead ? " read " : ""} ${m.context || ''} `}>
                                    <div className="header">
                                        <div className="title">
                                            {/* {
                                                m.pinned &&
                                                <i className='ppi ppi-pin' />
                                            } */}
                                            {m.subject}
                                        </div>
                                        <div className="functions">
                                            {
                                                m.pinned ? 
                                                <TbPinned size={'1.2rem'} onClick={() => toggleMessageRead(m, 'pinned')} />
                                                :
                                                <TbPinnedOff size={'1.2rem'} onClick={() => toggleMessageRead(m, 'pinned')}  />
                                            }
                                            {/* <i className={` ppi ppi-${m.isRead ? "reply" : "pin"} ppi-3x`} /> */}
                                        </div>
                                    </div>
                                    <div className="when">{moment(m.notificationDateTime).format('DD/MM/YYYY HH:mm:ss')}</div>
                                    <div className="content" dangerouslySetInnerHTML={{ __html: m.content }} />
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                                        {
                                            m.isRead ?
                                            <IoCheckmarkDoneOutline />
                                            :
                                            <IoCheckmarkOutline />
                                        }
                                    </div>
                                </div>
                            )
                        })
                    : 
                    messages
                    .filter(m => !m.isRead || m.pinned)
                    .filter(m => m.subject.indexOf(search) >= 0 || m.content.indexOf(search) >= 0)
                    .sort((a, b) => { return a.notificationDateTime > b.notificationDateTime ? -1 : 1 })
                    .slice(0, msgs.size)
                    .map((m, i) => {
                        return (
                            <div key={i} className={`message${m.isRead ? " read " : ""} ${m.context || ''} `} onMouseLeave={() => { setTimeout(() => { !m.isRead && toggleMessageRead(m)}, 2000)}} >
                                <div className="header">
                                    <div className="title">
                                        {/* {
                                            m.pinned &&
                                            <i className='ppi ppi-pin' />
                                        } */}
                                        {m.subject}
                                    </div>
                                    <div className="functions">
                                    {
                                                m.pinned ? 
                                                <TbPinned size={'1.2rem'} onClick={() => toggleMessageRead(m, 'pinned')} />
                                                :
                                                <TbPinnedOff size={'1.2rem'} onClick={() => toggleMessageRead(m, 'pinned')}  />
                                            }
                                    </div>
                                </div>
                                <div className="when">{moment(m.notificationDateTime).format('DD/MM/YYYY HH:mm:ss')}
                                
                                </div>
                                <div className="content" dangerouslySetInnerHTML={{ __html: m.content }} />
                                {/* <i className={` ppi ppi-${m.isRead ? "reply" : "check"} ppi-3x`} onClick={() => toggleMessageRead(m)} /> */}
                                <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                                    {
                                        m.isRead ?
                                        <IoCheckmarkDoneOutline />
                                        :
                                        <IoCheckmarkOutline />
                                    }
                                </div>
                            </div>
                        )
                    })
                }

                {
                    ((
                        messages.filter(msg => msg.pinned).length === 0 &&
                        messages.filter(msg => !msg.isRead).length === 0
                    ) && !showAllMessages) ?
                        <>
                            <div className='allread'>
                                <i className='ppi ppi-information-circle' />
                                <span>Todas as notificações ja foram lidas</span>
                            </div>
                        </>
                        :
                        <>
                            {
                                msgs.size < messages
                                    .filter(m => !m.pinned && (!m.isRead || showAllMessages))
                                    .filter(m => m.subject.indexOf(search) >= 0 || m.content.indexOf(search) >= 0)
                                    .length &&
                                <div className='centralized'>
                                    <span className='font-sm'>Carregar mais notificações</span>
                                    <PPIconLink
                                        icon='ppi ppi-plus'
                                        onClick={() => {
                                            dispatch({ type: 'MSG_SIZE', payload: msgs.size + 10 });
                                        }} />
                                </div>
                            }
                        </>
                }
            </div>
        </div>
    );

}

export default Notifications;